module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading",
    attrs: {
      "id": "loading"
    }
  }, [_c('div', {
    staticClass: "circle"
  })]), _vm._v(" "), (_vm.pageStatus == 1) ? _c('div', {
    staticClass: "main",
    attrs: {
      "id": "indexPage"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../images/index_top.png"),
      "alt": "",
      "width": "100%"
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "detail clearfix"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.toRange()
      }
    }
  }, [_vm._v("查看保险详情")])]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('qa', {
    attrs: {
      "type": 1
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "logo-image"
  }), _vm._v(" "), _c('div', {
    staticClass: "copyright"
  }, [_vm._v("南京尚网网络科技有限公司对以上信息保留最终解释权")]), _vm._v(" "), (_vm.createBtn == 1) ? _c('p', {
    staticClass: "button",
    staticStyle: {
      "position": "fixed",
      "bottom": "0"
    },
    attrs: {
      "id": "createBtn"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("免费参保")]) : _vm._e(), _vm._v(" "), (_vm.createBtn == 2) ? _c('p', {
    staticClass: "button",
    staticStyle: {
      "position": "fixed",
      "bottom": "0"
    },
    attrs: {
      "id": "createBtn"
    },
    on: {
      "click": _vm.goCreate
    }
  }, [_vm._v("免费参保")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.pageStatus == 2) ? _c('div', {
    staticClass: "main",
    staticStyle: {
      "margin-top": "0"
    },
    attrs: {
      "id": "voucherPage"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_c('p', {
    staticClass: "zhongan"
  }, [_vm._v("WiFi安全险")]), _vm._v(" "), (_vm.obj.status == 1) ? _c('div', {
    staticClass: "already"
  }, [_vm._v("已参保")]) : _vm._e(), _vm._v(" "), (_vm.obj.status == 2) ? _c('div', {
    staticClass: "already",
    staticStyle: {
      "color": "#0285F0"
    }
  }, [_vm._v("处理中")]) : _vm._e(), _vm._v(" "), (_vm.obj.status == 1) ? _c('p', {
    staticClass: "status"
  }) : _vm._e(), _vm._v(" "), (_vm.obj.status == 2) ? _c('p', {
    staticClass: "status"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "logo"
  }), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "al-item"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("保障期限")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm.obj.start_time) + "至2023年9月15日")])]), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "al-item"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("保险详细")]), _vm._v(" "), _c('a', {
    staticClass: "right a",
    attrs: {
      "href": "#/range"
    },
    on: {
      "click": _vm.clickRange
    }
  }, [_vm._v("保障范围")])]), _vm._v(" "), _c('div', {
    staticClass: "al-item",
    staticStyle: {
      "padding-bottom": "24px"
    }
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("服务热线")]), _vm._v(" "), _c('a', {
    staticClass: "right a",
    attrs: {
      "href": "tel:4009999595"
    },
    on: {
      "click": _vm.range
    }
  }, [_vm._v("400-999-9595")])])]), _vm._v(" "), _c('qa', {
    attrs: {
      "type": 2
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "logo-image"
  }), _vm._v(" "), _c('div', {
    staticClass: "copyright"
  }, [_vm._v("南京尚网网络科技有限公司对以上信息保留最终解释权")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "fixed",
      "bottom": "0",
      "width": "100%",
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "bottom_btn",
    class: {
      halfwidth: _vm.claimList
    },
    attrs: {
      "id": "btn_claim"
    },
    on: {
      "click": _vm.goClaim
    }
  }, [_vm._v("我要索赔")]), _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.claimList),
      expression: "claimList"
    }],
    staticClass: "bottom_btn claimList",
    class: {
      halfwidth: _vm.claimList
    },
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "to": "/claimList"
    }
  }, [_c('div', {
    on: {
      "click": _vm.clickClaimList
    }
  }, [_vm._v("索赔记录")])])], 1)], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "model"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "title"
  }), _vm._v(" "), _c('p', {
    staticClass: "content"
  }), _vm._v(" "), _c('p', {
    staticClass: "btns",
    staticStyle: {
      "display": "none"
    }
  }, [_c('span', {
    staticClass: "cancel"
  }, [_vm._v("取消")]), _vm._v(" "), _c('span', {
    staticClass: "confirm"
  }, [_vm._v("确定")])]), _vm._v(" "), _c('p', {
    staticClass: "foot"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner"
  }, [_c('img', {
    attrs: {
      "src": require("../images/index_wifilogo.png"),
      "width": "31.733%"
    }
  }), _vm._v(" "), _c('p', [_vm._v("一键连WiFi，一直有保障")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "protect"
  }, [_c('p', [_vm._v("保障清单")]), _vm._v(" "), _c('div', {
    staticClass: "line left"
  }), _vm._v(" "), _c('div', {
    staticClass: "line right"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "detail-item"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("连WiFi意外损失累计最高赔付")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._v("￥"), _c('span', {
    staticClass: "big"
  }, [_vm._v("100,000")]), _vm._v("元")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "detail-item"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("连WiFi意外损失单次最高赔付")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._v("￥"), _c('span', {
    staticClass: "big"
  }, [_vm._v("20,000")]), _vm._v("元")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "detail-item"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("保障期限")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._v("一年")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "detail-item"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("参保费用")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._v("￥"), _c('span', {
    staticClass: "big"
  }, [_vm._v("0.00")]), _vm._v("元")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "detail clearfix"
  }, [_c('div', {
    staticClass: "protect"
  }, [_c('p', [_vm._v("专属特色")]), _vm._v(" "), _c('div', {
    staticClass: "line left"
  }), _vm._v(" "), _c('div', {
    staticClass: "line right"
  })]), _vm._v(" "), _c('div', {
    staticClass: "left-panel"
  }, [_c('div', {
    staticClass: "icon icon1"
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#333333"
    }
  }, [_vm._v("全方位保障")]), _vm._v(" "), _c('p', [_vm._v("所有通过WiFi万能钥匙")]), _vm._v(" "), _c('p', [_vm._v("连WiFi的上网行为")])]), _vm._v(" "), _c('div', {
    staticClass: "right-panel"
  }, [_c('div', {
    staticClass: "icon icon2"
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#333333"
    }
  }, [_vm._v("官方VIP通道")]), _vm._v(" "), _c('p', [_vm._v("极速处理您的WiFi安全")]), _vm._v(" "), _c('p', [_vm._v("险理赔需求")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "al-item",
    staticStyle: {
      "margin-top": "16px"
    }
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("累计最高赔付人民币")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._v("￥100000元")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "al-item"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("单日/单次最高赔付人民币")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._v("￥20000元")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "al-item"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("支付金额")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._v("￥0.00元")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d68c69a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Index.vue
// module id = 818
// module chunks = 1